<script setup lang="ts">
import type {NavigationMenuItem} from '@nuxt/ui'
import LGLogoDark from "~/components/logo/LGLogoDark.vue";
import LGLanguageSwitcherLinks from "~/components/header/LGLanguageSwitcherLinks.vue";
import LGAccountIcon from "~/components/header/LGAccountIcon.vue";
import LGCartIcon from "~/components/header/LGCartIcon.vue";
import LGBurgerIcon from "~/components/header/LGBurgerIcon.vue";
import { ref } from 'vue'
import {useAuthStore} from "~~/stores/auth";

const auth = useAuthStore();

const { t } = useI18n()
const localePath = useLocalePath()

const isMenuOpen = ref(false)

const handleMenuOpen = (value: boolean) => {
    isMenuOpen.value = value
}

const mainMenuItems = computed<NavigationMenuItem[]>(() => {
    const items: NavigationMenuItem[] = [
        {
            label: t("header.menuItems.shop"),
            to: localePath('vodici'),
        },
        {
            label: t("header.menuItems.ourStory"),
            to: localePath('moja-zgodba'),
        },
        {
            label: t("header.menuItems.forParents"),
            to: localePath('za-starse'),
        },
    ]

    if (auth.user != null) {
        items.push({
            label: t("header.menuItems.myGuides"),
            to: localePath('moj-racun-moji-vodici'),
        })
    }

    return items
})

</script>

<template>
    <UHeader v-model:open="isMenuOpen" mode="drawer" :toggle="{class: 'hidden'}" :to="localePath('/')" role="banner">
        <template #title>
            <LGLogoDark/>
        </template>

        <template #right>
            <div class="flex gap-2.5 lg:gap-4.5 items-center">
                <UNavigationMenu :items="mainMenuItems" class="hidden lg:flex" role="navigation" />
                <LGAccountIcon/>
                <LGCartIcon/>
                <LGLanguageSwitcherLinks/>
                <LGBurgerIcon @toggle="handleMenuOpen"/>
            </div>
        </template>

        <template #body>
            <div class="flex flex-col gap-8">
                <UNavigationMenu :items="mainMenuItems" orientation="vertical" role="navigation"/>
            </div>
        </template>
        <template #bottom>
            <div class="w-full h-[20px] bg-[url(/images/header/header-bg.svg)] bg-bottom"></div>
        </template>
    </UHeader>
</template>

<style>
.navigation-menu-link {
    font-family: "Quicksand", "sans-serif"
}
</style>
